interface SegControlProps<T extends string> {
  value: T;
  options: readonly T[];
  onChange: (value: T) => void;
  className?: string;
}

export function SegControl<T extends string>({
  value,
  options,
  onChange,
  className = "",
}: SegControlProps<T>) {
  return (
    <div className={`se-seg ${className}`}>
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          className={value === opt ? "active" : ""}
          onClick={() => onChange(opt)}
        >
          {opt}
        </button>
      ))}
    </div>
  );
}
